import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";
import { PROCESS_STEPS } from "../data/content";
import { PROCESS_IMGS } from "../data/images";

const OUTCOMES = [
  "Clear scope, goals & success metrics",
  "Signed-off roadmap & architecture",
  "Validated, pixel-perfect designs",
  "Working software, demoed weekly",
  "Test reports & quality sign-off",
  "Live product, zero downtime",
  "Monitored, supported & evolving",
];

export default function Process() {
  return (
    <main className="pt-28">
      <section data-testid="process-page-section" className="section-pad !pt-8">
        <div className="container-x">
          <SectionHead badge="How We Work" title="Our Development Process"
            sub="A proven 7-step journey from first conversation to long-term partnership — transparent at every stage." />
          <div className="max-w-4xl mx-auto space-y-6">
            {PROCESS_STEPS.map((p, i) => (
              <motion.div key={p.step} data-testid={`process-page-step-${i + 1}`}
                initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: 0.05 }} whileHover={{ y: -4 }}
                className="glass-card rounded-2xl p-6 sm:p-7 flex items-start gap-5">
                <span className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-500 text-white font-mono text-lg font-semibold flex items-center justify-center shadow-[0_8px_24px_rgba(99,102,241,0.4)]">
                  {p.step}
                </span>
                <div className="flex-1">
                  <h3 className="font-display font-semibold text-lg sm:text-xl">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
                  <p className="mt-2.5 text-xs font-mono uppercase tracking-widest text-primary">Outcome: {OUTCOMES[i]}</p>
                </div>
                <img src={PROCESS_IMGS[i]} alt={`${p.title} stage`}
                  className="hidden sm:block shrink-0 w-40 h-28 rounded-xl object-cover border border-border/60" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="process-cta-section" className="section-pad bg-secondary/40 border-t border-border/60">
        <div className="container-x text-center">
          <Reveal>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Ready to start Step 01?</h2>
            <p className="mt-4 text-muted-foreground max-w-xl mx-auto">Discovery is free. Tell us about your idea and we'll map the road ahead.</p>
            <Link to="/contact" data-testid="process-cta-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-indigo-500 to-blue-500 px-7 py-3.5 text-sm font-semibold text-white shadow-[0_8px_30px_rgba(99,102,241,0.45)] hover:-translate-y-0.5 transition-all duration-200">
              Start Discovery <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
